@if (validRange | async; as validRangeObj) {
  <div class="d-flex align-center padding-top-l padding-bottom-l">
    <!-- Use text + inputmode so native number steppers are not shown. -->
    <ion-input
      id="from-input"
      type="text"
      inputmode="numeric"
      [(ngModel)]="grade.rangeFrom"
      class="border-light-2 padding-left"
      [class.border-error]="(!valid && !(grade.validRangeFrom() || grade.markRangeValid())) || !validRangeObj.valid"
      (ionBlur)="validateRange()"
      aria-label="grade range from"
      mode="md"
    ></ion-input>
    <span class="padding-s">-</span>
    <ion-input
      id="to-input"
      type="text"
      inputmode="numeric"
      [(ngModel)]="grade.rangeTo"
      class="border-light-2"
      [class.border-error]="(!valid && !grade.validRangeTo()) || !validRangeObj?.valid"
      (ionBlur)="validateRange()"
      mode="md"
      aria-label="grade range to"
    ></ion-input>
  </div>
  @if (!valid && !(grade.markValid() && grade.markRangeValid() && validRangeObj?.valid)) {
    <div
      class="color-error margin-top-xs margin-bottom-l d-flex"
      >
      @if (showRangeErrorMessage() && !validRangeObj?.valid) {
        <span class="d-flex align-center padding-right-xs font-l" id="alert-span">
          <ion-icon aria-hidden="true" name="alert-circle-sharp" id="alert-icon"></ion-icon>
        </span>
      }
      @if (!grade.markRangeValid()) {
        <span
          aria-label="Minimum value must be smaller than maximum value. E.g. 80 to 100."
          id="min-val-bigger-than-max"
          >Minimum value must be smaller than maximum value. E.g. 80-100.</span
          >
        } @else {
          @if (!grade.markValid()) {
            <span aria-label="Please enter a number between 0 to 120." id="num-between-0-120"
              >Please enter a number between 0-120.</span
              >
            } @else {
              @if (validRangeObj.duplicate && showRangeErrorMessage()) {
                <span
                  aria-label="Can not have duplicate range."
                  id="duplicate-range"
                  >Can not have duplicate range.</span
                  >
                } @else {
                  @if (validRangeObj.overlap && showRangeErrorMessage()) {
                    <span aria-label="Ranges can not overlap each other." id="range-overlap"
                      >Ranges can not overlap each other.</span
                      >
                    }
                  }
                }
              }
            </div>
          }
        }
